import Auth from "../auth/Auth";
import { ApiConfigCompany, BidNavVersion } from "../models/ApiConfigCompany";

export class ApiConfigBase {
    static selectedCompany: ApiConfigCompany | undefined = undefined;

    getAvailableCompanies(): ApiConfigCompany[] {
        return [];
    }

    setSelectedCompany(company: ApiConfigCompany) {
        ApiConfigBase.selectedCompany = company;
    }

    getSelectedCompany(): ApiConfigCompany {
        if (!ApiConfigBase.selectedCompany) {
            let allComps = this.getAvailableCompanies();
            let user = Auth.getDecodedToken();
            var comp = allComps.find(c => c.bidNavVersion == user?.ver && c.companyId === user?.company) || allComps[0];
            this.setSelectedCompany(comp);
            return comp;
        } else {
            return ApiConfigBase.selectedCompany;
        }
    }

    
    isLegacy() : boolean{
        return this.getSelectedCompany().bidNavVersion !== BidNavVersion.BidNav20;
    }

    
    isUk() : boolean{
        return this.getSelectedCompany().bidNavVersion === BidNavVersion.UK;
    }

    getBidNavUrlForCustomer(customerId: number, adminUserId: number) {
        let company = this.getSelectedCompany();
        if (company.bidNavVersion === BidNavVersion.BidNav20) {
            return `${company.bidNavApiUrl}/auth/admlogin/${adminUserId}/${customerId}/${company.bnKey}`;
        } else {
            let qs = `key=${company.bnKey}&id=${customerId}&a=${adminUserId}&p=p`;
            return `${company.bidNavUrl}/admauto.aspx?${qs}`;
        }
    }
}

